<router-outlet></router-outlet>
<ngx-ui-loader fgsType="three-strings" fgsColor="#ee5530" [fgsSize]="70" text="please wait ..." textColor="#FFFFFF"
  textPosition="center-center" pbColor="#ee5530" pbDirection="ltr" [pbThickness]="4" [hasProgressBar]="true">
</ngx-ui-loader>